module.exports = __webpack_public_path__ + "img/ourwork_banner.a2798a57.png";